import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=76f7a496&scoped=true&"
import script from "./GroupTable.vue?vue&type=script&lang=js&"
export * from "./GroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f7a496",
  null
  
)

export default component.exports